import { getDataByPath } from './dataHelpers';

export const isFindingListWidget = (widgetType) => {
    if (!widgetType) return false;
    // Finding widgets that display lists: key-findings, open-ports, findings-grid
    const findingListWidgets = ['key-findings', 'open-ports', 'findings-grid'];
    return findingListWidgets.includes(widgetType);
};

export const isAuditTableWidget = (widgetType) => {
    if (!widgetType) return false;
    const auditTableWidgets = [
        'ad-users-audit-table', 'ad-computers-audit-table', 'ad-devices-audit-table',
        'ad-groups-audit-table', 'ad-ous-audit-table', 'ad-domain-controllers-audit-table',
        'ad-gpo-policies-audit-table', 'ad-event-logs-audit-table',
        'ms365-scan-proof-table', 'microsoft-policies-table',
        'localhost-hardware-information-table', 'localhost-system-information-table',
        'localhost-installed-applications-table', 'localhost-event-logs-table',
        'localhost-open-ports-audit-table'
    ];
    return auditTableWidgets.includes(widgetType);
};

export const isAutoWidget = (widgetType) => {
    if (!widgetType) return false;

    // Auto widgets are Finding Widgets, Summary Widgets, or Chart Widgets for Scans
    // These have dataType: 'auto' and don't require a data source selection
    const autoWidgetTypes = [
        // Findings & Security widgets
        'findings-status', 'key-findings', 'open-ports', 'findings-grid',
        'open-ports-summary', 'darkweb-summary', 'accounts-summary',
        'accounts-admin-summary', 'firewall-summary', 'localhost-firewall-findings-summary', 'localhost-firewall-cost-summary', 'localhost-service-risk-summary', 'localhost-service-cost-summary', 'localhost-os-cost-summary', 'localhost-open-ports-cost-summary', 'service-risk-summary',
        'overall-risk-score',
        'security-scan-grid',
        'cyber-security-threat-exposure',
        // Chart widgets for scans (Localhost, Network, Active Directory)
        'user-password-status', 'disk-free-used', 'firewall-status',
        'service-start-modes', 'admin-password-status', 'password-strength',
        'hibp-breach-status', 'windows-version', 'common-software',
        'hibp-status', 'rdp-status', 'browser-status', 'system-age',
        'open-ports-chart', 'device-type', 'network-sensitive-ports', 'network-firewall-status-chart',
        'ad-object-types', 'ad-objects-pie-chart', 'fsmo-roles',
        'active-inactive-users', 'password-expiry', 'active-inactive-computers',
        'group-types', 'ou-membership', 'gpo-timeline',
        // Summary widgets
        'backups-summary', 'backups-cost-summary',
        'admins-password-pie-chart', 'admins-finding-summary', 'admins-cost-summary',
        'accounts-password-pie-chart', 'accounts-finding-summary', 'accounts-cost-summary',
        'network-firewall-findings-summary', 'network-firewall-cost-summary',
        'network-encryption-cost-summary',
        'network-service-risk-summary', 'network-service-cost-summary',
        'network-open-ports-cost-summary',
        'ad-computer-cost-summary', 'ad-users-cost-summary', 'ad-groups-cost-summary', 'ou-cost-summary', 'fsmo-cost-summary', 'gpo-cost-summary',
        'ad-admins-cost-summary', 'ad-admins-status-pie',
        'os-risk-summary', 'os-cost-summary',
        'total-cost-calculator',
        // Proof tables (these also don't need data source)
        'ad-all-users-table', 'ad-inactive-users-table', 'ad-all-computers-table',
        'ad-inactive-computers-table', 'ad-groups-risk-table', 'ad-ous-risk-table',
        'ad-fsmo-roles-table', 'ad-gpo-analysis-table', 'ad-workstation-age-table',
        'ad-users-audit-table', 'ad-computers-audit-table', 'ad-devices-audit-table',
        'ad-groups-audit-table', 'ad-ous-audit-table', 'ad-domain-controllers-audit-table',
        'ad-gpo-policies-audit-table', 'ad-event-logs-audit-table',
        'ms365-scan-proof-table', 'microsoft-policies-table',
        'localhost-hardware-information-table', 'localhost-system-information-table',
        'localhost-installed-applications-table', 'localhost-event-logs-table',
        'localhost-open-ports-audit-table',
        'ms365-inactive-users-table',
        'network-backup-status-table', 'network-users-no-expiring-password-table',
        'network-users-expiring-password-table', 'network-os-versions-table',
        'network-admins-no-expiring-password-table', 'network-admins-expiring-password-table',
        'network-admins-daily-work-table', 'network-non-default-services-table',
        'network-all-open-ports-table', 'network-sensitive-open-ports-table',
        'network-antivirus-status-table', 'network-encryption-status-table',
        'network-firewall-status-table', 'network-detailed-services-table',
        'network-services-risk-breakdown-table', 'network-high-privilege-services-table',
        'network-logical-disks-table',
        'localhost-all-users-password-table', 'localhost-non-expiring-passwords-table',
        'localhost-disk-usage-table', 'localhost-firewall-status-table', 'localhost-os-version-table', 'localhost-sensitive-open-ports-table', 'localhost-services-risk-breakdown-table', 'localhost-high-privilege-services-table', 'pii-detected-table',
        'localhost-installed-software-table', 'localhost-non-default-services-table',
        'localhost-open-ports-table', 'localhost-browser-passwords-table',
        'ms365-inactive-users-table', 'ms365-all-users-mfa-table',
        'ms365-users-without-mfa-table', 'ms365-policy-config-table', 'ms365-users-pie-chart',
        'ms365-mfa-pie-chart', 'ms365-policy-pie-chart',
        'inactive-ms-users-summary', 'inactive-ms-users-cost-summary', 'mfa-summary', 'mfa-cost-summary',
        'hibp-breached-credentials-table', 'hibp-exposure-by-platform-table',
        'pii-detection-pie-chart', 'pii-detected-table', 'pii-type-summary-table', 'pii-finding-summary', 'pii-cost-summary',
        // External Risk Scan widgets
        'external-risk-score', 'external-domain-info', 'external-category-breakdown',
        'external-all-findings-table', 'external-warnings-table', 'external-passed-table',
        'external-compliance-table', 'external-severity-pie', 'external-status-pie',
        'external-category-bar', 'external-dns-findings', 'external-email-findings',
        'external-ssl-findings', 'external-headers-findings', 'external-infrastructure-findings',
        'external-breach-findings'
    ];

    return autoWidgetTypes.includes(widgetType);
};

export const getCostSummaryItemName = (widgetType) => {
    const mapping = {
        'backups-cost-summary': 'Backups',
        'admins-cost-summary': 'Admin Accounts',
        'accounts-cost-summary': 'Accounts',
        'firewall-cost-summary': 'Firewall',
        'network-firewall-cost-summary': 'Firewall',
        'localhost-firewall-cost-summary': 'Localhost Firewall',
        'os-cost-summary': 'OS',
        'localhost-os-cost-summary': 'Localhost OS',
        'network-service-cost-summary': 'Services',
        'localhost-service-cost-summary': 'Localhost Services',
        'network-open-ports-cost-summary': 'Open Ports',
        'localhost-open-ports-cost-summary': 'Localhost Open Ports',
        'ad-computer-cost-summary': 'AD Computers',
        'ad-users-cost-summary': 'AD Users',
        'ad-groups-cost-summary': 'AD Groups',
        'ou-cost-summary': 'OU',
        'fsmo-cost-summary': 'FSMO',
        'gpo-cost-summary': 'GPO',
        'ad-admins-cost-summary': 'Admin Accounts',
        'pii-cost-summary': 'PII',
        'mfa-cost-summary': 'MFA',
        'inactive-ms-users-cost-summary': 'MS Users',
        'policy-configuration-cost-summary': 'Policy Configuration',
        'network-encryption-cost-summary': 'Encryption'
    };
    return mapping[widgetType] || null;
};

export const isCostSummaryWidget = (widgetType) => {
    return getCostSummaryItemName(widgetType) !== null;
};

export const getDefaultUnitCost = (widgetType) => {
    const itemName = getCostSummaryItemName(widgetType);
    if (!itemName) return 0;

    const UNIT_COSTS = {
        'Backups': 50,
        'Admin Accounts': 100,
        'Accounts': 50,
        'Firewall': 30,
        'OS': 50,
        'Services': 50,
        'Open Ports': 30,
        'AD Computers': 50,
        'AD Users': 50,
        'AD Groups': 40,
        'OU': 40,
        'FSMO': 50,
        'GPO': 20,
        'PII': 100,
        'MFA': 50,
        'MS Users': 50,
        'Policy Configuration': 100,
        'Encryption': 50,
        'Localhost Firewall': 50,
        'Localhost Services': 50,
        'Localhost OS': 50,
        'Localhost Open Ports': 30
    };

    return UNIT_COSTS[itemName] || 0;
};

export const getDefaultItemsPerPage = (widgetType) => {
    const defaults = {
        'table': 15,
        'key-findings': 15,
        'open-ports': 20,
        'findings-grid': 5,
        'network-backup-status-table': 20,
        'network-os-versions-table': 20,
        'network-firewall-status-table': 10,
        'network-detailed-services-table': 20,
        'network-non-default-services-table': 20,
        'network-services-risk-breakdown-table': 20,
        'network-high-privilege-services-table': 10,
        'network-users-no-expiring-password-table': 20,
        'network-users-expiring-password-table': 20,
        'network-admins-no-expiring-password-table': 20,
        'network-admins-expiring-password-table': 20,
        'network-admins-daily-work-table': 20,
        'network-sensitive-open-ports-table': 20,
        'ad-groups-risk-table': 5,
        'ad-ous-risk-table': 20,
        'ad-fsmo-roles-table': 7,
        'ad-gpo-analysis-table': 20,
        'ms365-inactive-users-table': 20,
        'ms365-users-without-mfa-table': 20,
        'ms365-all-users-mfa-table': 20,
        'network-antivirus-status-table': 20,
        'localhost-high-privilege-services-table': 20,
        'pii-detected-table': 10,
        'ad-admins-table': 15
    };

    return defaults[widgetType] || 20;
};

// Get available fields from data at a specific path (Recursive)
export const getAvailableFields = (data, path = '') => {
    const targetData = path ? getDataByPath(data, path) : data;
    if (!targetData) return [];

    const fields = new Set();
    const MAX_DEPTH = 5; // Limit recursion depth

    const collectFields = (obj, prefix = '', depth = 0) => {
        if (depth > MAX_DEPTH || !obj || typeof obj !== 'object') return;

        Object.keys(obj).forEach(key => {
            // Skip internal fields
            if (key.startsWith('_') || key === 'children') return;

            const currentPath = prefix ? `${prefix}.${key}` : key;
            const value = obj[key];

            // Always add the current path
            fields.add(currentPath);

            // Recurse if object
            if (value && typeof value === 'object') {
                if (Array.isArray(value)) {
                    // Scan up to 5 items in the array to find an object to recurse into
                    // (handles mixed formats: some items are arrays/primitives, others are objects)
                    for (let ai = 0; ai < Math.min(value.length, 5); ai++) {
                        if (typeof value[ai] === 'object' && value[ai] !== null && !Array.isArray(value[ai])) {
                            collectFields(value[ai], currentPath, depth + 1);
                            break; // Found an object to recurse into
                        }
                    }
                } else {
                    collectFields(value, currentPath, depth + 1);
                }
            }
        });
    };

    if (Array.isArray(targetData)) {
        // Scan first 100 items to catch optional fields and mixed data formats
        targetData.slice(0, 100).forEach(item => {
            if (item && typeof item === 'object') {
                collectFields(item);
            }
        });
    } else if (typeof targetData === 'object') {
        collectFields(targetData);
    }

    return Array.from(fields).sort();
};

// Helper to get nested value by path (used in Device Filters)
export const getNestedValueForFilters = (obj, path) => {
    if (!obj || !path) return undefined;

    const parts = [];
    let current = '';
    let inBracket = false;

    for (let i = 0; i < path.length; i++) {
        const char = path[i];
        if (char === '[') {
            if (current) { parts.push(current); current = ''; }
            inBracket = true;
        } else if (char === ']') {
            if (current) { parts.push(current); current = ''; }
            inBracket = false;
        } else if (char === '.' && !inBracket) {
            if (current) { parts.push(current); current = ''; }
        } else {
            current += char;
        }
    }
    if (current) parts.push(current);

    let result = obj;
    for (const part of parts) {
        if (result === null || result === undefined) return undefined;
        if (/^\d+$/.test(part) && Array.isArray(result)) {
            result = result[parseInt(part, 10)];
        } else {
            result = result[part];
        }
    }
    return result;
};
